module.exports = "/images/edit-red.svg?aca7633fafc5e7dd4d38bca7f3dc5c9f";